module.exports = __webpack_public_path__ + "assets/img/ocean_warrior-b2f745d3.jpg";